import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { IconAlfaLogo } from '@alfa-bank/site-icon/alfa-logo';
import { Link } from '@alfa-bank/site-link';
import cn from 'classnames';

import styles from '../../styles/styles.css';

interface IAlfaIconProps {
    href: string;
}

export const AlfaIcon = ({ href }: IAlfaIconProps) => {
    return (
        <Link
            border="hidden"
            className={cn(styles.external, styles.link)}
            href={href}
            noUnderline
            styler={{ marginRight: 32 }}
            title={'alfaIcon'}
        >
            <IconAlfaLogo className={styles.iconLogo} height={40} width={28} />
        </Link>
    );
};
